import React from "react";
import { createRoot } from "react-dom/client";
import { initI18nFromSSR } from "./i18n/initFromSSR";
import ProductPublicReviewList from "./features/productdetail/ProductPublicReviewList";

// Initialize i18n from SSR data và đợi load xong trước khi render
initI18nFromSSR().then(() => {
  const root = document.getElementById("reviews-container");
  if (root) {
    // Get the product ID from the data attribute
    const productId = root.getAttribute("data-product-id");

    if (productId && !isNaN(Number(productId))) {
      createRoot(root).render(
        <ProductPublicReviewList productId={Number(productId)} />
      );
    } else {
      console.error("Product ID not found or invalid");
    }
  }
});

